<template>
<div class="chapter">
<div class="inner_page">
<p class="colophon"><span>Europa Editions<br/>
 1 Penn Plaza, Suite 6282<br/>
New York, N.Y. 10019<br/>
  info@europaeditions.com<br/>
  www.europaeditions.com<br/>
<br/>
  This book is a work of fiction. Any references to historical events, real people, or real locales are used fictitiously.<br/>
<br/>
  Copyright © 2019 by L’iconoclaste, Paris<br/>
  First publication 2021 by Europa Editions<br/>
<br/>
  Translation by Tina Kover<br/>
  Original Title: <i>Une bête au paradis<br/></i>Translation copyright © 2021 by Europa Editions<br/>
<br/>
  All rights reserved, including the right of reproduction in whole or in part in any form.<br/>
<br/>
  Book design by Emanuele Ragnisco<br/>
  www.mekkanografici.com<br/>
<br/>
  Original cover design by Quintin Leeds<br/> 
  Cover image: Istockphoto.com/tbratford<br/>
<br/>
  ISBN 9781609456481 <br/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Colophon.vue?0ebef98c